import * as types from './types';
import { login } from './LoginForm/actions';
import * as accountTypes from 'account/types';

export default (state = {}, action) => {
  switch (action.type) {
    case types.AUTHENTICATE:
    case types.SET_REDIRECT:
      return {
        ...state,
        redirectTo: action.payload.redirectTo
      }
    case types.AUTHENTICATION_SUCCEEDED:
    case login.SUCCESS:
      return {
        ...state,
        user: action.payload.data,
      }
    case types.RESET_CODE_SENT:
      return {
        ...state,
        resetEmail: action.payload.resetEmail,
      }
    case accountTypes.AUTOPAY_CHANGE:
      return {
        ...state,
        user: {
          ...state.user,
          autopay_enabled: action.payload.enabled,
        }
      }
    case types.SHOW_VERICATION_CODE:
      console.log(action)
      return {
        ...state,
        showVerificationCode: true,
        forceShowVerification: new Date().toISOString(),
        timerTime: action.payload && action.payload.timerTime,
      }
    case types.SET_MDN_VALID:
      return {
        ...state,
        mdnValid: true,
      }
    case types.RESET_MDN_VALID:
      return {
        ...state,
        mdnValid: false,
      }
    default:
      return state;
  }
}

export const getUser = (state) => state.user;
export const getResetEmail = (state) => state.resetEmail;
export const getAutopayEnabled = (state) => state.user && state.user.autopay_enabled;
export const getAuthRedirect = (state) => state.redirectTo;
export const getShowVerificationCode = (state) => state.showVerificationCode;
export const getLoginTimerTime  = (state) => state.timerTime;
export const getMdnValid = (state) => state.mdnValid;
export const getForceShowVerification = (state) => state.forceShowVerification;
